import { render } from "./results-nav-button.vue?vue&type=template&id=4dc36fbc"
import script from "./results-nav-button.vue?vue&type=script&lang=js"
export * from "./results-nav-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__